import React from 'react';
import { motion } from 'framer-motion';
export function Proof() {
  return <section className="py-24 bg-brand-sage-light/40 px-6 relative overflow-hidden" data-id="element-200">
      <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/cream-paper.png')] opacity-30 mix-blend-multiply pointer-events-none" data-id="element-201"></div>
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-202">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-203">
          <h2 className="font-serif italic text-3xl md:text-4xl text-brand-navy mb-10 leading-relaxed font-medium" data-id="element-204">
            Imagina el próximo miércoles...
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-brand-navy/80 leading-relaxed font-serif" data-id="element-205">
            <p data-id="element-206">
              Tu hijo empieza a desregularse. Sientes el inicio de la tensión.
            </p>
            <p data-id="element-207">Pero esta vez, no sientes pánico. Tienes un plan.</p>
            <p data-id="element-208">Aplicas el paso 1. Aplicas el paso 2.</p>
            <p data-id="element-209">
              En menos de dos minutos, él está respirando contigo. No hubo
              gritos. No hubo platos rotos. No hubo culpa.
            </p>
            <p className="text-2xl md:text-3xl font-medium text-brand-sage-dark mt-8 italic" data-id="element-210">
              Solo dos personas recuperando la calma juntas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}